import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
} from "@angular/core";

@Component({
  selector: "app-consulta-csv",
  templateUrl: "./consulta-csv.component.html",
  styleUrls: ["./consulta-csv.component.scss"],
})
export class ConsultaCsvComponent implements OnInit, OnChanges {
  @Input() consulta: any;
  @Input() titulo = "";
  @Input() idConsulta = "";
  @Input() tipoConsulta = "";
  @Input() codigoControle = "";
  @Input() token = "";

  @Output() update = new EventEmitter();

  statusMsg = null;
  status = "info";
  texto: any;
  ufMun: string[] = [];
  uf: string = "";
  municipio: string = "";
  dataUltimaAtualizacao: Date = null;
  inspecaoCsvSemDados: boolean = false;

  constructor() {}

  ngOnInit() {
    this.setStatus();
  }

  ngOnChanges() {
    this.setStatus();
  }

  setStatus() {
    this.inspecaoCsvSemDados = false;

    if (this.consulta?.ufJurisdicao) {
      this.ufMun = this.consulta?.ufJurisdicao?.split("/");
      this.uf = this.ufMun[1];
      this.municipio = this.ufMun[0];
    }
    if (this.consulta?.dataUltimaAtualizacao) {
      this.dataUltimaAtualizacao = new Date(
        this.consulta?.dataUltimaAtualizacao
      );
    }

    if (
      this.codigoControle !== "ERRO_FORNECEDOR" &&
      (this.consulta?.listaCsvnacional == null ||
        this.consulta?.listaCsvnacional?.length == 0)
    ) {
      this.inspecaoCsvSemDados = true;
      this.statusMsg = "INSPEÇÃO";
      this.texto =
        "NÃO FORAM ENCONTRADAS INSPEÇÕES VEICULARES CSV PARA ESTE VEÍCULO.";
    }
  }
}
